
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
XHeader,
Group,
XInput,
XButton
},
data() {
return {
isShowBuy: true,
status: 0,
statusCn: "（未激活）",
code: ""
};
},
created() {
var localConfigInfo = this.$store.getters.getConfigInfo;
if (
localConfigInfo != undefined &&
localConfigInfo.AgentCode != undefined
) {
this.isShowBuy = false;
}

this.$http({
method: "post",
url: "wxexam.ashx?op=CheckCourseType",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId
}
})
.then(response => {
if (
response.status == 200 &&
response.data.errcode == 0 &&
parseInt(response.data.data) > 0
) {
this.status = 1;
this.statusCn = "（已激活）";
this.code = response.data.errmsg;
}
})
.catch(function(error) {
console.log("error:" + error);
});
},
methods: {
registCourse() {
if (this.status == 1) {
this.$vux.toast.text("您已激活该课程，无需再次激活", "bottom");
return;
}

if (this.code.length == 0) {
this.$vux.toast.text("请输入激活码!", "bottom");
return;
}


this.$http({
method: "post",
url: "wxexam.ashx?op=RegistCourseByCode",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
serialcode: this.code
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
this.$vux.toast.text("激活成功！", "bottom");
this.$router.go(-1);
} else {
this.$vux.toast.text(response.data.data, "bottom");
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
},
openUrl2() {


this.$http({
method: "post",
url: "wxexam.ashx?op=GetSettingValue",
params: {
itemName: 'cpayurl'
}
})
.then(response => {
if (response.status == 200) {
if (response.data) {
window.location.href = response.data;
} else {
window.location.href = "http://www.tangzheguo.com/subject.html";
}
}
})
.catch(function(error) {
console.log("error:" + error);
});

},
openUrl() {
if (this.status == 1) {
this.$vux.toast.text("您已激活该课程，无需再次购买", "bottom");
return;
}
this.$vux.loading.show({
text: "请稍候..."
});


this.$http({
method: "post",
url: "wxexam.ashx?op=CreateSaleOrderForRegist",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId
}
})
.then(response => {
this.$vux.loading.hide();

if (response.status == 200) {
if (response.data.errcode == 0) {
this.wxPay(response.data.data);
} else {
this.$vux.toast.text(response.data.errmsg, "bottom");
}
}
})
.catch(function(error) {

this.$vux.loading.hide();
});
},
wxPay(jsPay) {
var _this = this;
WeixinJSBridge.invoke("getBrandWCPayRequest", jsPay, function(res) {
if (res.err_msg == "get_brand_wcpay_request:ok") {
_this.$vux.toast.text("支付成功！", "bottom");
_this.$router.go(-1);
} else if (res.err_msg == "get_brand_wcpay_request:cancel") {
_this.$vux.toast.text("用户取消支付", "bottom");
} else if (res.err_msg == "get_brand_wcpay_request:fail") {
_this.$vux.toast.text("微信支付失败", "bottom");
} else {
_this.$vux.toast.text("支付异常", "bottom");
}
});
}
},
computed: {
showCourseName: function() {
var classInfo = this.$store.getters.getClassInfo;
return classInfo != undefined ? classInfo.CourseName : "";
},
statusColor: function() {
return this.status == 1 ? "#ff0000" : "#000";
}
}
};



// WEBPACK FOOTER //
// ./src/components/ClassBuy.vue